const schema = () => ({
  title: 'Hero',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'variant',
        'image_side',
        'image',
        'image_alt',
        'eyebrow',
        'heading',
        'description',
      ],
    },
    {
      id: 'meta',
      title: 'Métadonnées',
      fields: [
        'show_address',
        'address_override',
        'show_service',
        'show_phone',
        'phone_override',
      ],
    },
  ],
  properties: {
    variant: {
      title: 'Variante',
      type: 'string',
      choices: [
        ['editorial', "Éditorial — légende sur l'image"],
        ['split', 'Split — texte + image côte à côte'],
      ],
      default: 'editorial',
    },
    image_side: {
      title: "Position de l'image",
      type: 'string',
      choices: [
        ['right', 'Image à droite'],
        ['left', 'Image à gauche'],
      ],
      default: 'right',
    },
    image: {
      title: 'Image hero',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
    image_alt: {
      title: 'Texte alternatif',
      type: 'string',
    },
    eyebrow: {
      title: 'Surtitre',
      type: 'string',
      default: 'Restaurant · Jodoigne · Cuisine française',
    },
    heading: {
      title: 'Titre principal',
      type: 'string',
      default: 'Sous la lumière du jour.',
    },
    description: {
      title: 'Texte',
      type: 'string',
      widget: 'textarea',
    },
    show_address: {
      title: "Afficher l'adresse",
      type: 'boolean',
      default: true,
    },
    address_override: {
      title: 'Adresse personnalisée',
      type: 'string',
      widget: 'textarea',
    },
    show_service: {
      title: 'Afficher les horaires de service',
      description:
        'Les jours de service viennent du bloc Horaires de la page d’accueil.',
      type: 'boolean',
      default: true,
    },
    show_phone: {
      title: 'Afficher le téléphone',
      type: 'boolean',
      default: true,
    },
    phone_override: {
      title: 'Téléphone personnalisé',
      type: 'string',
    },
  },
  required: [],
});

export default schema;
